module.exports = __webpack_public_path__ + "img/worker.518ba20.svg";